import React, { CSSProperties } from 'react';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import { IconButton } from '@mui/material';

export enum FeatureLike {
  Neutral,
  Liked,
  Disliked,
}

const neutralStyle: CSSProperties = {
  fontSize: '18px',
  color: 'var(--c-grey-600)',
};

const likedStyle: CSSProperties = {
  fontSize: '18px',
  color: 'var(--c-green-600)',
};

const dislikedStyle: CSSProperties = {
  fontSize: '18px',
  color: 'var(--c-red-600)',
};

export const FeatureLikes: React.FC<{
  liked: FeatureLike;
  toggleIsLiked: () => void;
  toggleIsDisliked: () => void;
}> = ({ liked, toggleIsLiked, toggleIsDisliked }) => {
  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <IconButton color="primary" size="small" onClick={toggleIsLiked}>
        {[FeatureLike.Neutral, FeatureLike.Disliked].includes(liked) ? (
          <ThumbUpOffAltIcon sx={neutralStyle} />
        ) : (
          <ThumbUpAltIcon sx={likedStyle} />
        )}
      </IconButton>
      <IconButton color="primary" size="small" onClick={toggleIsDisliked}>
        {[FeatureLike.Neutral, FeatureLike.Liked].includes(liked) ? (
          <ThumbDownOffAltIcon sx={neutralStyle} />
        ) : (
          <ThumbDownAltIcon sx={dislikedStyle} />
        )}
      </IconButton>
    </span>
  );
};
